import { Body, Box, Heading } from '@hover/blueprint';
import React from 'react';

import { Component as EmptyIcon } from 'src/assets/img/empty-design.svg';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

export const EmptyDesign = () => {
  const t = useTranslate(TranslationNamespace.DESIGN_STUDIO);
  return (
    <Box display="grid" justifyContent="center" textAlign="center">
      <Box justifyContent="center" marginBottom={400} testId="homeowner-design">
        <EmptyIcon />
      </Box>
      <Heading size={300} testId="empty-design">
        {t('menu.designConfigCard.emptyDesign')}
      </Heading>
      <Body size={400} testId="empty-design-body">
        {t('menu.designConfigCard.emptyDesignBody')}
      </Body>
    </Box>
  );
};
